<template>
  <div class="n_ruleList">
    <div class="flex alitem_center" @click="jump(1)">
      <span>1.商品配送</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(2)">
      <span>2.系统交易规则</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(3)">
      <span>3.开具发票注意事项</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(4)">
      <span>4.消费者权益保护</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(5)">
      <span>5.退换货政策</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(6)">
      <span>6.酒水平台相关规则</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(7)">
      <span>7.食品安全投诉举报处理制度</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(8)">
      <span>8.食品安全违法行为制止及报告制度</span>
      <span class="iconfont iconnext"></span>
    </div>
    <div class="flex alitem_center" @click="jump(9)">
      <span>9.用户服务协议</span>
      <span class="iconfont iconnext"></span>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    jump(id) {
      this.$router.push({ path: './rule', query: { id: id } })
    },
  },
}
</script>

<style scoped lang="scss">
.n_ruleList {
  padding: 20px;
}
.alitem_center {
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #ccc;
}
</style>